import React from "react";
import { CheckCircle2, XCircle, Clock, AlertTriangle } from "lucide-react";

const map = {
  ok: { cls: "status-ok", icon: CheckCircle2, label: "OK" },
  not_ok: { cls: "status-not-ok", icon: XCircle, label: "NOT OK" },
  pending: {
    cls: "bg-slate-100 text-slate-600 border border-slate-300",
    icon: Clock,
    label: "Gözləyir",
  },
  active: {
    cls: "bg-blue-50 text-blue-700 border border-blue-300",
    icon: Clock,
    label: "Aktiv",
  },
  approved: { cls: "status-ok", icon: CheckCircle2, label: "Təsdiqlənib" },
  rejected: { cls: "status-not-ok", icon: XCircle, label: "Rədd edilib" },
  awaiting_team_lead: {
    cls: "bg-amber-50 text-amber-700 border border-amber-300",
    icon: AlertTriangle,
    label: "Team Lead-i gözləyir",
  },
  sub_requested: {
    cls: "bg-orange-50 text-orange-700 border border-orange-300",
    icon: AlertTriangle,
    label: "Korreksiya",
  },
};

export default function StatusBadge({ status, label, testId }) {
  const conf = map[status] || map.pending;
  const Icon = conf.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${conf.cls}`}
      data-testid={testId || `status-${status}`}
    >
      <Icon className="w-3.5 h-3.5" aria-hidden="true" />
      {label || conf.label}
    </span>
  );
}
